import React, {useEffect} from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UserDataForm from '../../global-elements/userDataForm'
import ValidatorService from "../../../../services/validator";
import TC from "../../add-ons/TC";
import Banner from "../../../body/banners/banner";
import '../../../../assets/terms/dm-terms.css';
import marketing from "../../../../services/marketing"
import Acknowledgements from "../../add-ons/Acknowledgements";
import CreditProtection from "../../add-ons/CreditProtection";
import OverlimitPrivilege from "../../add-ons/OverlimitPrivilege";
import Features from "../../global-elements/feature";
import ErrorModal from "../../../body/forms/components/ErrorModal";
import Recaptcha from "../../../body/forms/components/recaptcha/Recaptcha";
import InvalidStateModal from "../../global-elements/invalidStateModal";
import PixelsService from '../../../../services/pixels';
import ColorCardChoiceForm from "../../global-elements/colorCardChoiceForm";
import '../../../../assets/standalone/standalone.css';
import Esign from "../../add-ons/esign";
import AudioEyeSupport from "../../../../services/audioEyeSupport";
import ConfirmSmsConsent from "../../global-elements/confirmsSmsConsent";
import SubmitApplicationService from "../../../../services/submitApplication";
import AdobeScript from "../../../../services/adobeScript";
import Econsent from '../../global-elements/eConsent';
import FeaturesService from "../../../../services/features";
import AxiosWrapper from "../../../../services/axios";
import Wildcard from "../../../../services/wildcard";
import MfaSms from "../../global-elements/mfa/mfaSms";
import MfaEmail from "../../global-elements/mfa/mfaEmail";
import DeadEndMFa from "../../global-elements/mfa/deadEndMfa";
import { InactiveDetection } from "../../../../services/inactiveDetection";
import SocialProofPopup from "../../global-elements/satisfactionPopup";
import ExitOverlayModal from "../../global-elements/exitOverlayModal";
import { PRODUCT } from "../../../../models/websiteTypesConstants";
import { ExperianBanner } from "../../../body/banners/experianBanner";
import OfferExpirationNotice from "../../add-ons/OfferExpirationNotice";
import GBBanner from "../../../body/banners/gbBanner";

function Landing() {

    const ada = new AudioEyeSupport();
    const Setting = useStoreState((state) => state.siteSettingsModel);
    const MainPath = useStoreState((state) => state.siteSettingsModel.MainPath);
    const setGrandBanckDeclined = useStoreActions((actions) => actions.siteSettingsModel.setGrandBanckDeclined);
    const info = useStoreState((state) => state.applicantModel.applicant);
    const setInfo = useStoreActions(actions => actions.applicantModel.setApplicant);
    const setApplicationResult = useStoreActions(actions => actions.applicationResultModel.setApplicationResult);
    const resultStep = useStoreActions(actions => actions.setDisplayResult);
    const history = useHistory();
    const getRoutingSettings = useStoreActions(state => state.routingSettingsModel.getRoutingSettings);
    const [errorShow, setErrorShow] = useState(false);
    const closeError = () => setErrorShow(false);
    const InvalidState = useStoreState((state) => state.invalidState);
    const setInvalidState = useStoreActions((actions) => actions.setInvalidState);
    const [errorMessage, setErrorMessage] = useState(false);
    const validatorService = new ValidatorService();
    const methods = useForm({mode: 'onSubmit'});
    const [isLoading, setLoading] = useState(false);
    let brandSettings = useStoreState((state) => state.siteSettingsModel.brandSettings);
    const [recaptchaDisabled, setRecaptchaDisabled] = useState(true);
    const utms = new marketing();
    const pendingInfo = ["FROZEN", "FROZENPREQUAL", "PENDFEE", "PENDFUNDING", "PENDINFO", "PENDINTERNAL"];
    const setInitPixels = useStoreActions(actions => actions.setInitPixels);
    const initPixels = useStoreState(state => state.initPixels);
    const PixelService = new PixelsService();
    const bannerbgImageSurgeReflexDesktop = Setting.brandSettings.ProductName === PRODUCT.Surge ? 
    "https://imagestest.continentalfinance.net/applicationweb/Surge/Surge-Stand-Alone-500-Card-Art-Lower.png"
    : (Setting.brandSettings.ProductName === PRODUCT.Reflex ? "https://imagestest.continentalfinance.net/applicationweb/Reflex/feature_section.png"
        : brandSettings.CardImage);
    const submitApplicationService = SubmitApplicationService();
    const adobe = new AdobeScript();
    const [isHalfScrolled, setIsHalfScrolled] = useState(false);
    const features = new FeaturesService();
    const setDeclineOffers = useStoreActions(actions => actions.siteSettingsModel.setDeclineOffers);
    const domain = useStoreState(state => state.siteSettingsModel.domain);
    const client = new AxiosWrapper()
    const setMfaSms = useStoreActions(actions => actions.setMfaSms);
    const wildcard = new Wildcard();
    const [tcHasErrors, setTcHasErrors] = useState(false);
    const isRecaptchaBlocking = Setting.productSettings.CaptchaKey !== null && recaptchaDisabled;
    const isDisabled = isLoading || tcHasErrors || isRecaptchaBlocking;
    const showOverlimit = wildcard.isFeatureEnabled('OverlimitSettings');

    InactiveDetection.setInactiveTitle("Don’t miss this great offer!");

    useEffect(() => {
        if(!initPixels) {
            utms.mapper();
            ada.setup();
            utms.trackEvent(19, "STANDALONE", "", Setting.productSettings.ProductId, "Flow");
            PixelService.initialize().pageView("/landing").event("google", "STANDALONE", "Landing Page");
            getRoutingSettings({ Url: Setting.domain, Route: window.location.pathname});
            setInfo({ index : 'ProductCode', value : Setting.mainSettings.ProductCode })
            setInfo({ index : 'Url', value : domain });
            adobe.setup();
            setTimeout(() =>  adobe.startEvent('page_view'), 5000);
            setInitPixels(true)
        }
        
    }, []);

    useEffect(() => {
        const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const fullHeight = document.body.scrollHeight;
        const scrolledToBottom = scrollPosition + windowHeight;

        if (scrolledToBottom >= fullHeight / 2) {
        if(isHalfScrolled === false){
            
            setIsHalfScrolled(true)
        }
        
        }
    };
    
    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
    }, [isHalfScrolled]);

    useEffect(() => {
    if (isHalfScrolled) {
        scrollEvent();
    }
    }, [isHalfScrolled]);

    const scrollEvent = () => {
        adobe.event('scroll')
    };

    const submit = async (data) => {
        setLoading(true)


            if (!validatorService.preValidations(data, methods, info) ) {
                if(await validatorService.EmailValidate(info.Email, methods)){
                  if(await validatorService.addressValidateV2(info, methods, setInvalidState) === true){

                    if(wildcard.isFeatureEnabled('MFAActive')){
                        let mfaId = await client.get('/mfa-id',{})
                        sessionStorage.setItem('mfaId', mfaId);
                        let result = await client.post('/send-Mfa', {
                            contactIdentifier : info.PrimaryPhone,
                            contactType : 'Text', 
                            ApplicantId : 0,
                            WebUrl : Setting.domain
                            }, true)
                        if(result && result.Success === true){
                            sessionStorage.setItem('sessionToken', result.Payload)
                            setMfaSms(true)
                            return
                        }
                        setErrorShow(true);
                        setErrorMessage('An unknown error has occured. Please try again.')
                        return
                  }else{
                    await submitApplication();
                    
                  }  }
                }
              }
        setLoading(false)
      }

    async function submitApplication(){
        let response = await submitApplicationService.submitApplication(info, true);
        let payload = response.Payload;

        if (response.Success){
            if (payload) {
                adobe.event('apply_now_click', Setting.CardColors.find(value => value.Code === info.cardColorCode))
                if (payload.IsGrandbank === true) { setGrandBanckDeclined(true); }
        
                if (payload.result != null) {
                if(payload.result){     utms.updateSessionReport("appResult",   payload.result.toUpperCase() ); }
                if(payload.ref_number){ utms.updateSessionReport("applicantId", payload.ref_number); }
                window.cl = payload.credit_limit ?? 0;
                //Decline Offers for BMG box
                setDeclineOffers(payload.DeclineOffers || null);
            
                setInfo({ index: "step", value: 3 });
                setApplicationResult(payload);
                resultStep(true);
                window.scrollTo(0, 0);

                if (payload.result.toUpperCase() === "APPROVED") {
                    history.push(MainPath + "approved" + window.location.search);
                    return;
                }

                //New Bank Account call for Dynamic call
                if(features.isLinkBankAccountFeatureEnabled() && payload.result.toUpperCase() === 'PENDUSER') {
                    history.push(MainPath + "link-account" + window.location.search);
                    return;
                }

                if (pendingInfo.includes(payload.result.toUpperCase())) {
                    history.push(MainPath + "pendinfo" + window.location.search);
                    return;
                }
                history.push(MainPath + "decision" + window.location.search);
                return;
                }
            } else {
                setErrorMessage("An unknown error has occured. Please try again.");
                setErrorShow(true);
                setLoading(false);
            }
        } else {
            payload.decline_message='We are currently processing your application, and you will receive a decision within 30 days.'
            setDeclineOffers(payload.DeclineOffers || null);
            setInfo({ index: "step", value: 3 });
            setApplicationResult(payload);
            resultStep(true);
            window.scrollTo(0, 0);
            history.push(MainPath +"decision" + window.location.search);
            return;
        }
    };

    return (
        <>
          {/*--- MFA stuff ---*/}
                {(wildcard.isFeatureEnabled('MFAActive')) && (
                        <>
                            <MfaSms />
                            <MfaEmail />
                            <DeadEndMFa />
                        </>
                        
                )}
            {/*--- END MFA stuff ---*/}
            <ExperianBanner />
            {brandSettings.ProductName === PRODUCT.Grand.bank
                ? <GBBanner />
                : <Banner />
            }
            <ErrorModal size="sm" show={errorShow} message={errorMessage} closeError={closeError}/>
            <ExitOverlayModal disabled={isLoading} />
            <InvalidStateModal visible={InvalidState} />
            
            <div className="container mt-3 mb-5">
                <SocialProofPopup></SocialProofPopup>
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(submit)}>
                        <div  className="dm-form">
                            <UserDataForm />
                        </div>

                        <div className="row">
                            <ColorCardChoiceForm />
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <h1 className="terms-header-title">E-Sign Disclosure</h1>
                            </div>
                            <Esign />
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <h1 className="terms-header-title">Pricing and Terms</h1>
                            </div>
                            <div className="col-12 ">
                                <div className="terms-wrapper">
                                    <TC data={{ productCode: Setting.mainSettings.ProductCode}} onTermsErrorChange={setTcHasErrors} />
                                </div>                                
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <h1 className="terms-header-title">Credit Protection</h1>
                            </div>
                            <CreditProtection />
                        </div>
                        {showOverlimit && (
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="terms-header-title">Overlimit Privilege</h1>
                                </div>
                                <OverlimitPrivilege />
                            </div>
                        )}
                        <div className="row">
                            <div className="col-12">
                                <h1 className="terms-header-title">Acknowledgements</h1>
                            </div>
                            <Econsent />
                            {Setting.smsConcentModuleStandAlone === true && (
                                <div className="col-12 mb-3">
                                    <div className="col-12">
                                        <ConfirmSmsConsent></ConfirmSmsConsent>
                                    </div>
                                </div>
                            )}
                            <Acknowledgements data={{productCode: Setting.mainSettings.ProductCode}} />
                        </div>
                        <div className="row">
                            <div className="captcha-container">
                                {Setting.productSettings.CaptchaKey !== null ? (
                                    <div className="form-group displayFlexCenter">
                                    <Recaptcha
                                        setRecaptchaDisabled={setRecaptchaDisabled}
                                        ProductName={brandSettings.ProductName}
                                    />
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                            <div className="row mt-3">
                                <div className="col-12 text-center">
                                    <button onClick={() => {
                                        PixelService.event("google", "STANDALONE", "Submit Application").event("Pinterest","custom","Submit Application");
                                        utms.trackEvent(21, "STANDALONE", "", Setting.productSettings.ProductId, "Flow");
                                        adobe.event('form_submit',  Setting.CardColors.find(value => value.Code === info.cardColorCode));
                                    }} 
                                    disabled={isDisabled} id="dm-submit-app" style={{backgroundColor : Setting.brandSettings.Tertiary, width : "22%", color: "white"}} className="btn text-small mt-3 rounded-pill" type="submit">
                                        {isLoading ? 'Submitting...' : (wildcard.isFeatureEnabled('MFAActive') ? 'Verify and Submit' : 'Submit Application') }
                                    </button>
                                    <div className="mt-4">
                                        <OfferExpirationNotice />
                                    </div>
                                </div>
                            </div>
                    </form>
                </FormProvider>
            </div>
            {
                brandSettings.ProductName !== PRODUCT.Grand.bank && (
                    <>
                    <div className="row pt-1 pb-1" id="header-text-container" style={{ backgroundColor:  "black" }}>
                        <div >
                            <h1 className="bold standalone-titles">The {brandSettings.ProductName} Mastercard Features</h1>
                        </div>
                    </div>
                    <div className="container mt-5 mb-5">
                        <div className="banner-mobile" style={{ display: "flex", justifyContent: "center" }}>
                            <img 
                                src={bannerbgImageSurgeReflexDesktop} 
                                style={{ width: (brandSettings.ProductName === PRODUCT.Surge) ? "100%" : (brandSettings.ProductName === PRODUCT.Revel ? "40%" : "70%"), margin: "auto" }} 
                                alt="Surge Features"
                            />
                        </div>
                        <Features />
                    </div>
                    </>
                )
            }
        </>
        
    );
}

export default Landing;
